import { MdSettingsInputComponent } from "react-icons/md";
import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Z [Dev] custom component",
  name: "customComponent",
  icon: MdSettingsInputComponent,
  type: "object",
  fields: [
    {
      name: "heading",
      title: "Heading",
      type: "sectionTitle"
    },
    {
      name: "componentName",
      title: "Component Name",
      type: "string"
    }
  ],
  preview: {
    select: {
      title: "heading.title",
      componentName: "componentName"
    },
    prepare({ title, componentName }) {
      return {
        title: multilingualStringPreview(title) || "([Dev] custom component)",
        subtitle: componentName
      };
    }
  }
});
